import { render, staticRenderFns } from "./IconZumi.vue?vue&type=template&id=1d1b15cc&"
import script from "./IconZumi.vue?vue&type=script&lang=js&"
export * from "./IconZumi.vue?vue&type=script&lang=js&"
import style0 from "./IconZumi.vue?vue&type=style&index=0&id=1d1b15cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports